// extracted by mini-css-extract-plugin
export default {"back_button":"BackArrowButton_back_button__CczAR"};